import React, { useState, useEffect } from 'react'
import { Container, ContainerInput, Option, ContainerIcon, ContainerListOptions } from './styles'
import { IconComponent } from '~/assets/icons/component'

import { useNormalizedFilter } from '~/hooks'
import { useBoldString } from '~/hooks/useBoldString'

export interface InputAutocompleteProps {
  handleSearch: (value: string) => void
  optionsList: string[]
}

let debounceTimer: ReturnType<typeof setTimeout> | null = null

export const InputAutocomplete: React.FC<InputAutocompleteProps> = ({ handleSearch, optionsList }) => {
  const [keyword, setKeyword] = useState<string>('')
  const [suggestionsOptions, setSuggestionsOptions] = useState<string[]>([])
  const [showOptionsContainer, setShowOptionsContainer] = useState<boolean>(false)

  const { filter } = useNormalizedFilter()
  const { boldString } = useBoldString()

  useEffect(() => {
    if (keyword.length >= 3) {
      setShowOptionsContainer(true)
      setSuggestionsOptions(
        filter(optionsList, {
          searchTerm: keyword
        })
      )
    } else {
      setSuggestionsOptions([])
      setShowOptionsContainer(false)
    }
  }, [keyword])

  const talkEnter = e => {
    if (e.key === 'Enter') {
      handleSearch(keyword)
      setShowOptionsContainer(false)
      setKeyword('')
    }
  }

  const handleSelectOption = value => {
    if (debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      setShowOptionsContainer(false)
    }, 50)

    handleSearch(value)
    setKeyword('')
  }

  const handleClickSearch = () => {
    handleSearch(keyword)
    setShowOptionsContainer(false)
    setKeyword('')
  }

  const renderInput = () => {
    return (
      <ContainerInput>
        <input
          data-testid="inputAutocomplete"
          onKeyDown={e => talkEnter(e)}
          type="text"
          placeholder="Pesquisar"
          value={keyword}
          onChange={e => setKeyword(e.target.value)}
        />
        <ContainerIcon onClick={() => handleClickSearch()}>
          <IconComponent name="search" />
        </ContainerIcon>
      </ContainerInput>
    )
  }

  const renderMessageResult = () => {
    const messageFound = (
      <p>
        Foram encontrados <strong>{`${suggestionsOptions.length}`} resultados</strong>
      </p>
    )
    const messageNotFound = <p>Nenhum resultado encontrado</p>

    return suggestionsOptions.length > 0 ? messageFound : messageNotFound
  }

  const renderOptionItemResult = (value: string, index: number) => {
    return (
      <li key={index}>
        <Option onClick={() => handleSelectOption(value)}>
          <>{boldString(value, keyword)}</>
        </Option>
      </li>
    )
  }

  const renderListOptions = () => {
    return (
      <ContainerListOptions>
        {renderMessageResult()}
        <ul>{suggestionsOptions.map(renderOptionItemResult)}</ul>
      </ContainerListOptions>
    )
  }

  return (
    <Container>
      {renderInput()}
      {showOptionsContainer && renderListOptions()}
    </Container>
  )
}
